import React, { useState } from 'react';
import Select from 'react-select';

const ShippingDtlsTab = () => {
const [disableHawbIssuedBy, setDisableHawbIssuedBy] = useState(true);

// Placeholder options (replace these with actual data)
const joborderOptions = [];
const agentOptions = [];
const customerOptions = [];
const quotationOptions = [];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="card px-3 py-2">
                    <div className="row">


                        <div className="col-md-6 mt-2">
                            <label className="form-label   mb-0">Shipment Number</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label   mb-0">Master Number</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label className="form-label   mb-0">House Number</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label className="form-label   mb-0">Cargo type</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label className="form-label   mb-0">Quantity</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default ShippingDtlsTab